import { combineReducers } from "redux";
import fip from "./fipReducer";
import accounts from "./accountReducer";
import consent from "./consent";
import authenticationReducer from "./authenticationReducer";
import loader from "./loadingReducer";
import user from "./userReducer";

export default combineReducers({
  fip,
  accounts,
  consent,
  authenticationReducer,
  loader,
  user,
});
